import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const reviews = [
  {
    quote: "My skin has quite literally never looked better. The redness is gone, and my barrier feels completely restored after just two weeks.",
    author: "Elena R.",
    product: "The Complete Ritual"
  },
  {
    quote: "The Awakening Cleanser is a revelation. It cleans deeply but leaves my skin feeling hydrated, never tight.",
    author: "Sarah M.",
    product: "The Awakening Cleanser"
  },
  {
    quote: "Finally, a routine that feels luxurious but is simple enough that I actually stick to it every single night.",
    author: "Jessica T.",
    product: "Barrier Defense Cream"
  }
];

const Reviews = () => {
  return (
    <section className="py-24 md:py-32 bg-stone-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl md:text-5xl text-stone-900 mb-4">Words from our Community</h2>
          <div className="flex justify-center gap-1 text-stone-800">
            {[...Array(5)].map((_, i) => (
              <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-current w-5 h-5" />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="p-8 border border-stone-200 bg-white flex flex-col h-full"
            >
              <SafeIcon icon={FiIcons.FiMessageSquare} className="w-6 h-6 text-stone-300 mb-6" />
              <p className="text-stone-700 font-serif text-lg italic leading-relaxed mb-8 flex-grow">
                "{review.quote}"
              </p>
              <div>
                <p className="font-medium text-sm tracking-wide uppercase text-stone-900">{review.author}</p>
                <p className="text-xs text-stone-500 mt-1">Verified Buyer — {review.product}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;